import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cancel"]

  connect() {
    this.focusFrame = requestAnimationFrame(() => {
      const field = this.element.querySelector("[aria-invalid='true'], input:not([type='hidden']), select, textarea")
      field?.focus({ preventScroll: true })
    })
  }

  disconnect() {
    if (this.focusFrame) cancelAnimationFrame(this.focusFrame)
  }

  cancel(event) {
    if (!this.hasCancelTarget || event.defaultPrevented) return

    event.preventDefault()
    this.cancelTarget.click()
  }
}
